export default __webpack_public_path__ + "static/media/marigolds.f651de84.jpg";